(()=>{
/** ESD homepage 2.1: supports both document and Shopify theme-container scrolling. */
function mountHomeMotion(root) {
 const clamp=(v,min=0,max=1)=>Math.min(max,Math.max(min,v));
 const smooth=v=>{const x=clamp(v);return x*x*(3-2*x);};
 const motion=matchMedia('(prefers-reduced-motion: reduce)');
 const stacks=[...root.querySelectorAll('[data-esd-stack]')].map(el=>({el,stage:el.querySelector('.esd-pinned-stage'),panels:[...el.querySelectorAll('[data-esd-panel]')],jumps:[...el.querySelectorAll('[data-esd-jump]')]}));
 const focuses=[...root.querySelectorAll('[data-esd-focus]')];
 const reveals=[...root.querySelectorAll('[data-esd-reveal]')];
 const videos=[...root.querySelectorAll('video[data-esd-ambient]')];
 const wants=new WeakMap();
 const findScrollRoot=()=>{
  for(let el=root.parentElement;el&&el!==document.documentElement;el=el.parentElement){
   if(el!==document.scrollingElement&&/(auto|scroll|overlay)/.test(getComputedStyle(el).overflowY))return el;
  }
  return null;
 };
 let scrollRoot=findScrollRoot();
 const viewport=()=>{
  const top=scrollRoot?scrollRoot.getBoundingClientRect().top+scrollRoot.clientTop:0;
  return{top,height:scrollRoot?scrollRoot.clientHeight:innerHeight,y:scrollRoot?scrollRoot.scrollTop:scrollY};
 };
 let paused=motion.matches,raf=0,destroyed=false;
 const paint=()=>{
  raf=0;if(destroyed)return;
  const reduced=motion.matches,view=viewport(),vh=view.height;
  root.classList.toggle('esd-motion-ready',!reduced);
  root.classList.toggle('esd-has-scrolled',view.y>80);
  for(const stack of stacks){
   const rect=stack.el.getBoundingClientRect(),height=stack.stage.clientHeight;
   const maxPhase=Math.max(.6,(stack.panels.length-1)*1.4+.6);
   const phase=clamp((view.top-rect.top)/Math.max(1,rect.height-height))*maxPhase;
   let active=0;
   stack.panels.forEach((panel,i)=>{
    const arrival=i===0?1:clamp((phase-(i*1.4-.55))/.95);
    const next=i===stack.panels.length-1?0:clamp((phase-((i+1)*1.4-.55))/.95);
    const visible=reduced||(arrival>0&&next<1);
    panel.dataset.visible=String(visible);panel.inert=!visible;panel.setAttribute('aria-hidden',String(!visible));
    if(arrival>.62)active=i;
    if(!reduced){
     panel.style.setProperty('--scene-y',`${(1-arrival)*100}%`);
     const entry=i===0?1:smooth((arrival-.42)/.5),exit=smooth(next/.68);
     panel.style.setProperty('--copy-opacity',String(entry*(1-exit)));
     panel.style.setProperty('--copy-y',`${(1-entry)*48-exit*56}px`);
     panel.style.setProperty('--image-scale',String(1+(1-arrival)*.08+next*.025));
     panel.style.setProperty('--veil',String(next*.3));
    }
   });
   stack.jumps.forEach((button,i)=>{if(i===active)button.setAttribute('aria-current','step');else button.removeAttribute('aria-current');});
  }
  for(const el of focuses){
   const rect=el.getBoundingClientRect(),stage=el.querySelector('.esd-flight-stage');
   const inset=parseFloat(getComputedStyle(stage).top)||0;
   const p=clamp((view.top+inset-rect.top)/Math.max(1,rect.height-stage.clientHeight));
   el.style.setProperty('--flight-scale',String(reduced?1:.93+smooth(p/.32)*.07));
   el.style.setProperty('--flight-title-y',`${reduced?0:-smooth(p/.45)*28}px`);
   [...el.querySelectorAll('[data-esd-benefit]')].forEach((item,i)=>{
    const reveal=reduced?1:smooth((p-(.06+i*.17))/.16);
    item.style.setProperty('--benefit-opacity',String(.17+.83*reveal));
    item.style.setProperty('--benefit-y',`${(1-reveal)*16}px`);
   });
  }
  for(const el of reveals){
   const rect=el.getBoundingClientRect();
   const shift=parseFloat(el.style.getPropertyValue('--reveal-y'))||0;
   const scale=parseFloat(el.style.getPropertyValue('--reveal-scale'))||1;
   const top=rect.top-shift-el.offsetHeight*(1-scale)/2;
   const entry=reduced?1:smooth((view.top+vh*.95-top)/Math.min(260,vh*.31));
   el.style.setProperty('--reveal-opacity',String(entry));el.style.setProperty('--reveal-y',`${(1-entry)*54}px`);el.style.setProperty('--reveal-scale',String(.975+.025*entry));
  }
  for(const video of videos){
   const panel=video.closest('[data-esd-panel]'),rect=video.getBoundingClientRect();
   const visible=rect.bottom>view.top&&rect.top<view.top+vh&&(!panel||panel.dataset.visible==='true');
   const want=visible&&!paused&&!document.hidden;
   if(wants.get(video)!==want){wants.set(video,want);if(want)video.play().catch(()=>{});else video.pause();}
  }
  for(const button of root.querySelectorAll('[data-esd-pause]')){button.setAttribute('aria-pressed',String(paused));button.setAttribute('aria-label',`${paused?'Play':'Pause'} background videos`);}
 };
 const schedule=()=>{if(!raf&&!destroyed)raf=requestAnimationFrame(paint);};
 const jump=(stack,index)=>{
  if(motion.matches){stack.panels[index].scrollIntoView({behavior:'auto',block:'start'});return;}
  const rect=stack.el.getBoundingClientRect(),travel=rect.height-stack.stage.clientHeight,view=viewport();
  const phase=index===0?0:Math.min((stack.panels.length-1)*1.4+.6,index*1.4+.48);
  const target={top:view.y+rect.top-view.top+travel*phase/((stack.panels.length-1)*1.4+.6),behavior:'smooth'};
  if(scrollRoot)scrollRoot.scrollTo(target);else window.scrollTo(target);
 };
 const onClick=e=>{
  if(!(e.target instanceof Element))return;
  const pause=e.target.closest('[data-esd-pause]');if(pause){paused=!paused;schedule();return;}
  const button=e.target.closest('[data-esd-jump]');
  if(button){const stack=stacks.find(s=>s.el.contains(button));if(stack)jump(stack,Number(button.dataset.esdJump));return;}
  const a=e.target.closest('a[href^="#"]');if(!a||e.metaKey||e.ctrlKey||e.shiftKey||e.altKey)return;
  const hash=a.getAttribute('href').slice(1);
  for(const stack of stacks){const i=stack.panels.findIndex(p=>p.dataset.sceneId===hash);if(i>=0){e.preventDefault();jump(stack,i);return;}}
 };
 const onMotion=()=>{paused=motion.matches;schedule();};
 const onResize=()=>{scrollRoot=findScrollRoot();schedule();};
 const onFocus=e=>{if(!(e.target instanceof Element))return;const reveal=e.target.closest('[data-esd-reveal]');if(reveal){reveal.style.setProperty('--reveal-opacity','1');reveal.style.setProperty('--reveal-y','0px');}};
 root.addEventListener('click',onClick);root.addEventListener('focusin',onFocus);
 // Element scroll events do not bubble. Capture includes .page-wrapper and other theme scrollports.
 addEventListener('scroll',schedule,{passive:true,capture:true});addEventListener('resize',onResize,{passive:true});document.addEventListener('visibilitychange',schedule);motion.addEventListener('change',onMotion);
 const resize=new ResizeObserver(schedule);resize.observe(root);paint();
 return()=>{destroyed=true;cancelAnimationFrame(raf);resize.disconnect();root.removeEventListener('click',onClick);root.removeEventListener('focusin',onFocus);removeEventListener('scroll',schedule,true);removeEventListener('resize',onResize);document.removeEventListener('visibilitychange',schedule);motion.removeEventListener('change',onMotion);videos.forEach(v=>v.pause());root.classList.remove('esd-motion-ready');for(const s of stacks)for(const p of s.panels){p.inert=false;p.removeAttribute('aria-hidden');}};
}

if(!customElements.get('esd-home-section'))customElements.define('esd-home-section',class extends HTMLElement{connectedCallback(){if(this._cleanup)return;const start=()=>{if(this.isConnected&&!this._cleanup)this._cleanup=mountHomeMotion(this);};if(document.readyState==='loading'){this._ready=start;document.addEventListener('DOMContentLoaded',start,{once:true});}else start();}disconnectedCallback(){document.removeEventListener('DOMContentLoaded',this._ready);this._cleanup?.();this._cleanup=null;}});
})();
